import _ = require('underscore');

import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { isAnyItemFlowSubscription } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { changeSubscriptionsFormat } from '../actions/SubscriptionsActions';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';

export const ChangeSubscriptionsFormatEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionChangeFormat,
  translateName: Messages.changeSubscriptionsFormat_action,
  isVisible: (subscriptions) => !isAnyItemFlowSubscription(subscriptions),
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionsFormat(subscriptions)
};
